// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* src/pages/Dashboard/ProfilePage.scss */
.profile-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f9fb 0%, #ffffff 60%);
  color: #232137;
  display: flex;
  flex-direction: column;
  padding: max(12px, env(safe-area-inset-top, 0px)) max(12px, env(safe-area-inset-right, 0px)) max(24px, env(safe-area-inset-bottom, 0px)) max(12px, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
}
@media (min-width: 768px) {
  .profile-page {
    padding: 16px 24px 32px;
    align-items: center;
  }
}

.profile-page__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  max-width: 560px;
  width: 100%;
}

.profile-page__back {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border-radius: 999px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 0;
  color: #e72f44;
}

.profile-page__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.profile-page__content {
  max-width: 560px;
  width: 100%;
  margin: 0 auto;
}

/* карточка профиля */
.profile-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 14px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}
@media (min-width: 768px) {
  .profile-card {
    padding: 20px 20px;
    gap: 20px;
  }
}

.profile-card__avatar-wrap {
  flex: 0 0 auto;
}

.profile-card__avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  background: #f0f2f5;
}

.profile-card__avatar.fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
  color: #232137;
}

.profile-card__avatar.skeleton {
  animation: profilePagePulse 1.2s infinite;
}

.profile-card__info {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.profile-card__name {
  font-size: 18px;
  font-weight: 700;
}

.profile-card__email {
  font-size: 0.9rem;
  color: #777;
}

.profile-card__role {
  font-size: 0.92rem;
  color: #555;
}

.profile-card__role-accent {
  font-weight: 600;
  color: #e72f44;
}

.profile-card__error {
  margin-top: 4px;
  font-size: 0.85rem;
  color: #e72f44;
}

.profile-card__name,
.profile-card__email,
.profile-card__role,
.profile-card__error,
.profile-roles__error {
  overflow-wrap: anywhere;
}

/* блок смены роли */
.profile-roles {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.profile-roles__error {
  font-size: 13px;
  color: #e50040;
  text-align: center;
}

.profile-roles__change-btn {
  width: 280px;
  max-width: 100%;
  border-radius: 100px;
  border: none;
  padding: 15px 20px;
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
  background: #e50040;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.2s ease;
  box-shadow: 0 6px 16px rgba(229, 0, 64, 0.22);
}
.profile-roles__change-btn:hover:not(:disabled) {
  background: #bb0033;
}
.profile-roles__change-btn:disabled {
  background: #f2f2f5;
  color: #a0a0b0;
  box-shadow: none;
  cursor: default;
}

.profile-roles__refresh-btn {
  width: 280px;
  max-width: 100%;
  border-radius: 100px;
  border: 1px solid #e50040;
  padding: 15px 20px;
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
  background: #ffffff;
  color: #e50040;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.profile-roles__refresh-btn:hover:not(:disabled) {
  background: #fff2f5;
}
.profile-roles__refresh-btn:disabled {
  border-color: #e0e0e6;
  color: #a0a0b0;
  cursor: default;
}

/* модалка выбора роли */
.profile-role-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 12px;
  padding-top: max(12px, env(safe-area-inset-top, 0px));
  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
}

.profile-role-modal {
  background: #ffffff;
  border-radius: 18px;
  padding: 32px 24px 20px;
  width: min(430px, 100%);
  min-width: 0;
  max-width: 100%;
  max-height: calc(100vh - 24px);
  max-height: calc(100dvh - max(12px, env(safe-area-inset-top, 0px)) - max(12px, env(safe-area-inset-bottom, 0px)));
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.17);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  box-sizing: border-box;
  overflow: hidden;
}

.profile-role-modal__title {
  margin: 0 0 10px;
  font-weight: 700;
  font-size: 22px;
  color: #222;
  text-align: center;
  overflow-wrap: anywhere;
  flex: 0 0 auto;
}

.profile-role-modal__list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.profile-role-modal__item {
  width: 100%;
  flex: 0 0 auto;
  background: #e50040;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  padding: 13px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  white-space: normal;
  overflow-wrap: anywhere;
}

.profile-role-modal__item:hover {
  background: #bb0033;
}

.profile-role-modal__cancel {
  width: 100%;
  background: transparent;
  color: #666;
  font-size: 15px;
  font-weight: 500;
  padding: 11px 0 4px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.18s;
  flex: 0 0 auto;
}

.profile-role-modal__cancel:hover {
  background: #f6f6f7;
}

/* адаптивность */
@media (max-width: 480px) {
  .profile-card {
    align-items: flex-start;
  }
}
/* skeleton анимация */
@keyframes profilePagePulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProfilePage/ProfilePage.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,yCAAA;AAEA;EACE,iBAAA;EACA,4DAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kLAAA;EAIA,sBAAA;AAFF;AAIE;EAZF;IAaI,uBAAA;IACA,mBAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAAA;EACA,cAAA;AADF;;AAIA,qBAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAFF;AAIE;EAVF;IAWI,kBAAA;IACA,SAAA;EADF;AACF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,yCAAA;AADF;;AAIA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,WAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AADF;;AAIA;;;;;EAKE,uBAAA;AADF;;AAIA,oBAAA;AAEA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,6CAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAHJ;;AAOA;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iDAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,qBAAA;EACA,cAAA;EACA,eAAA;AALJ;;AASA,wBAAA;AAEA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,qDAAA;EACA,2DAAA;AAPF;;AAUA;EACE,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,iHAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;AAPF;;AAUA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,iCAAA;AAPF;;AAUA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,WAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,cAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA,iBAAA;AAEA;EACE;IACE,uBAAA;EARF;AACF;AAWA,sBAAA;AAEA;EACE;IAAO,YAAA;EATP;EAUA;IAAO,UAAA;EAPP;EAQA;IAAO,YAAA;EALP;AACF","sourcesContent":["/* src/pages/Dashboard/ProfilePage.scss */\r\n\r\n.profile-page {\r\n  min-height: 100vh;\r\n  background: linear-gradient(180deg, #f7f9fb 0%, #ffffff 60%);\r\n  color: #232137;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: max(12px, env(safe-area-inset-top, 0px))\n    max(12px, env(safe-area-inset-right, 0px))\n    max(24px, env(safe-area-inset-bottom, 0px))\n    max(12px, env(safe-area-inset-left, 0px));\n  box-sizing: border-box;\r\n\r\n  @media (min-width: 768px) {\r\n    padding: 16px 24px 32px;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.profile-page__header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  max-width: 560px;\r\n  width: 100%;\r\n}\r\n\r\n.profile-page__back {\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  border-radius: 999px;\r\n  border: none;\r\n  background: #ffffff;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  padding: 0;\r\n  color: #e72f44;\r\n}\r\n\r\n.profile-page__title {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n\r\n.profile-page__content {\r\n  max-width: 560px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* карточка профиля */\r\n\r\n.profile-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 16px 14px;\r\n  border-radius: 20px;\r\n  background: #ffffff;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\r\n  margin-bottom: 20px;\r\n\r\n  @media (min-width: 768px) {\r\n    padding: 20px 20px;\r\n    gap: 20px;\r\n  }\r\n}\r\n\r\n.profile-card__avatar-wrap {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.profile-card__avatar {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  background: #f0f2f5;\r\n}\r\n\r\n.profile-card__avatar.fallback {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  color: #232137;\r\n}\r\n\r\n.profile-card__avatar.skeleton {\r\n  animation: profilePagePulse 1.2s infinite;\r\n}\r\n\r\n.profile-card__info {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\r\n.profile-card__name {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n}\r\n\r\n.profile-card__email {\r\n  font-size: 0.9rem;\r\n  color: #777;\r\n}\r\n\r\n.profile-card__role {\r\n  font-size: 0.92rem;\r\n  color: #555;\r\n}\r\n\r\n.profile-card__role-accent {\r\n  font-weight: 600;\r\n  color: #e72f44;\r\n}\r\n\r\n.profile-card__error {\n  margin-top: 4px;\n  font-size: 0.85rem;\n  color: #e72f44;\n}\n\n.profile-card__name,\n.profile-card__email,\n.profile-card__role,\n.profile-card__error,\n.profile-roles__error {\n  overflow-wrap: anywhere;\n}\n\r\n/* блок смены роли */\r\n\r\n.profile-roles {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.profile-roles__error {\n  font-size: 13px;\n  color: #e50040;\n  text-align: center;\n}\n\n.profile-roles__change-btn {\n  width: 280px;\n  max-width: 100%;\n  border-radius: 100px;\n  border: none;\n  padding: 15px 20px;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 600;\n  background: #e50040;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  box-shadow: 0 6px 16px rgba(229, 0, 64, 0.22);\n\n  &:hover:not(:disabled) {\n    background: #bb0033;\n  }\n\n  &:disabled {\n    background: #f2f2f5;\n    color: #a0a0b0;\n    box-shadow: none;\r\n    cursor: default;\r\n  }\n}\n\n.profile-roles__refresh-btn {\n  width: 280px;\n  max-width: 100%;\n  border-radius: 100px;\n  border: 1px solid #e50040;\n  padding: 15px 20px;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 600;\n  background: #ffffff;\n  color: #e50040;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background: #fff2f5;\n  }\n\n  &:disabled {\n    border-color: #e0e0e6;\n    color: #a0a0b0;\n    cursor: default;\n  }\n}\n\n/* модалка выбора роли */\n\n.profile-role-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 12px;\n  padding-top: max(12px, env(safe-area-inset-top, 0px));\n  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));\n}\n\n.profile-role-modal {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 32px 24px 20px;\n  width: min(430px, 100%);\n  min-width: 0;\n  max-width: 100%;\n  max-height: calc(100vh - 24px);\n  max-height: calc(100dvh - max(12px, env(safe-area-inset-top, 0px)) - max(12px, env(safe-area-inset-bottom, 0px)));\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.17);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.profile-role-modal__title {\n  margin: 0 0 10px;\n  font-weight: 700;\n  font-size: 22px;\n  color: #222;\n  text-align: center;\n  overflow-wrap: anywhere;\n  flex: 0 0 auto;\n}\n\n.profile-role-modal__list {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 10px;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.profile-role-modal__item {\n  width: 100%;\n  flex: 0 0 auto;\n  background: #e50040;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.35;\n  padding: 13px 12px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.profile-role-modal__item:hover {\n  background: #bb0033;\n}\n\n.profile-role-modal__cancel {\n  width: 100%;\n  background: transparent;\n  color: #666;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 11px 0 4px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.18s;\n  flex: 0 0 auto;\n}\n\n.profile-role-modal__cancel:hover {\n  background: #f6f6f7;\n}\n\r\n/* адаптивность */\r\n\r\n@media (max-width: 480px) {\r\n  .profile-card {\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n/* skeleton анимация */\r\n\r\n@keyframes profilePagePulse {\r\n  0%   { opacity: .6; }\r\n  50%  { opacity: 1; }\r\n  100% { opacity: .6; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
